import rawConfig from '../rhumb-config.yaml';

// Bend's YAML loader parses rhumb-config.yaml into the shape
// RhumbProvider expects, but the TS resolver types all YAML as unknown.
export default rawConfig;